import { Reveal, SectionHeading } from "./Reveal";
import { BUSINESS } from "../config/business";

export const About = () => (
  <section id="about" className="relative bg-[#111214] py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
      <div className="order-2">
        <Reveal>
          <SectionHeading kicker="About Us" title="About Auto Trust Centre" />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-[#c9ccd2]">
            <p>
              Auto Trust Centre has served drivers in Mississauga since 2007.
              The shop was built around a simple idea: automotive repair should
              begin with proper diagnosis and end with work customers can feel
              confident about.
            </p>
            <p>
              As vehicle technology continues to evolve, the team continues
              adapting its knowledge, equipment and repair approach while
              maintaining the straightforward customer service expected from a
              trusted independent repair shop.
            </p>
            <p>
              From routine maintenance to diagnostics and mechanical repairs,
              Auto Trust Centre works to keep customers informed throughout the
              repair process.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 grid grid-cols-2 gap-px border border-white/10 bg-white/10">
            {[
              ["Domestic & Asian", "Vehicle Expertise"],
              ["All Makes", "And Models Serviced"],
            ].map(([a, b]) => (
              <div key={a} className="bg-[#0b0c0e] p-6">
                <p className="font-display text-lg font-bold uppercase text-[#f4f4f2]">
                  {a}
                </p>
                <p className="mt-1 text-sm text-[#a6a9b1]">{b}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal className="relative order-1">
        <div className="image-frame overflow-hidden">
          <img
            src="/images/shop-exterior.jpg"
            alt="Auto Trust Centre storefront with sign at 5040 Maingate Dr, Mississauga"
            loading="lazy"
            className="aspect-[16/10] w-full object-cover transition-transform duration-700 hover:scale-105"
          />
        </div>
        <div className="absolute -right-4 -top-4 z-10 bg-[#00AEEF] px-6 py-4 lg:-right-6 lg:-top-6">
          <p className="font-display text-center leading-none">
            <span className="block text-3xl font-extrabold text-[#06232e]">
              {BUSINESS.established}
            </span>
            <span className="mt-1 block text-[11px] font-bold uppercase tracking-[0.25em] text-[#06232e]/75">
              Est.
            </span>
          </p>
        </div>
        <div className="absolute -bottom-5 -left-5 hidden h-full w-full border border-white/10 lg:block" aria-hidden="true" />
      </Reveal>
    </div>
  </section>
);
